import {Select, Form, Divider, Switch, Input, Button, InputNumber} from 'antd';
import {update} from 'lodash';
import {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../common/hooks';
import {ORGANISATION_CONFIG, UPDATE_CONFIG} from './organisationConfig.type';
import {
  getOrganisationConfig,
  reloadConfig,
  updateOrganisationConfig,
} from './organisationConfigSlice';

const OrganisationConfig = () => {
  const [configForm] = Form.useForm();

  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.organisationConfig);
  useEffect(() => {
    dispatch(getOrganisationConfig())
      .unwrap()
      .then(() => {
        setOrganisation(state.orgConfig[0]);
      });
  }, []);

  const [organisation, setOrganisation] = useState<ORGANISATION_CONFIG>();

  const handleSelect = (e: string) => {
    state.orgConfig.map((x, i) => {
      if (x.organisationId === e) {
        setOrganisation(x);
        configForm.setFieldsValue({
          organisationId: x.organisationId,
          allowRackBilling: x.billingConfig.allowRackBilling,
          allowStationBilling: x.billingConfig.allowStationBilling,
          billingStrategy: x.billingConfig.billingStrategy,
          flatPrice: x.billingConfig.flatPrice,
          energyUnitPrice: x.billingConfig.energyUnitPrice,
          swappingMethod: x.swapConfig.swappingMethod,
          minimumBatterySoc: x.swapConfig.minimumBatterySoc,
        });
      }
    });
  };

  const handleFormFinish = (values: UPDATE_CONFIG) => {
    dispatch(updateOrganisationConfig(values))
      .unwrap()
      .then(() => {
        dispatch(reloadConfig());
      });
  };

  return (
    <div style={{paddingInline: '50px', paddingTop: '20px', width: '1000px'}}>
      <Form form={configForm} name='configForm' onFinish={handleFormFinish}>
        <div style={{paddingInline: '50px'}}>
          <Form.Item label='Organisation' name='organisationId'>
            <Select
              style={{width: '300px'}}
              onSelect={(e) => handleSelect(e)}
              placeholder='Select organisation'
            >
              {state.orgConfig.map((x, i) => (
                <Select.Option key={i} value={x.organisationId}>
                  {x.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <Divider orientation='left'>Billing Config</Divider>
        <div style={{paddingInline: '50px'}}>
          <Form.Item label='Allow Rack Billing' name='allowRackBilling' valuePropName='checked'>
            <Switch checkedChildren='True' unCheckedChildren='False' />
          </Form.Item>
          <Form.Item
            label='Allow Station Billing'
            name='allowStationBilling'
            valuePropName='checked'
          >
            <Switch checkedChildren='True' unCheckedChildren='False' />
          </Form.Item>
          <Form.Item label='Billing Strategy' name='billingStrategy'>
            <Select style={{width: '300px'}}>
              {organisation?.billing_strategy_options.map((x, i) => (
                <Select.Option key={i} value={x.value}>
                  {x.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label='Flat Price' name='flatPrice'>
            <InputNumber />
          </Form.Item>
          <Form.Item label='Energy Unit Price' name='energyUnitPrice'>
            <InputNumber />
          </Form.Item>
        </div>
        <Divider orientation='left'>Swap Config</Divider>
        <div style={{paddingInline: '50px'}}>
          <Form.Item label='Swap Method' name='swappingMethod'>
            <Select style={{width: '300px'}}>
              {organisation?.swapMethodOptions.map((x, i) => (
                <Select.Option key={i} value={x.value}>
                  {x.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label='Minimum Soc' name='minimumBatterySoc'>
            <InputNumber />
          </Form.Item>
        </div>
        <Divider />

        <div style={{paddingInline: '50px'}}>
          <Button type='primary' htmlType='submit'>
            {' '}
            Update Config
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default OrganisationConfig;
